import React from 'react';
import { Redirect, useHistory, useLocation, useParams } from 'react-router';
import * as QueryString from 'query-string';
import { BrowseCfg } from '../../conf';
import { BrowseResults } from './BrowseResults';
import { useGetBrowseResultsQuery } from '../../graphql/browse.generated';
import { LegacyBrowsePath } from './LegacyBrowsePath';
import { PageRoutes } from '../../conf/Global';
import { useEntityRegistry } from '../useEntityRegistry';
import { ComponentSpinner } from '../shared/ComponentSpinner';
import { scrollToTop } from '../shared/searchUtils';
import { ErrorSection } from '../shared/error/ErrorSection';

import utilService from '../../utils/util.service';
import { BrowseDataProduct } from './BrowseDataProduct';

type BrowseResultsPageParams = {
    type: string;
};

export const BrowseResultsPage = () => {
    const location = useLocation();
    const history = useHistory();
    const { type } = useParams<BrowseResultsPageParams>();

    const entityRegistry = useEntityRegistry();

    const rootPath = location.pathname;
    const params = QueryString.parse(location.search);
    const entityType = entityRegistry.getTypeFromPathName(type === 'dataproduct' ? 'dataProduct' : type);
    const pathComponents = rootPath.split('/').slice(3);

    // Decode special characters in the path
    const path = pathComponents.map((component) => utilService.decodeSpecialChars(component));

    const page: number = params.page && Number(params.page as string) > 0 ? Number(params.page as string) : 1;

    const { data, loading, error } = useGetBrowseResultsQuery({
        variables: {
            input: {
                type: entityType,
                path,
                start: (page - 1) * BrowseCfg.RESULTS_PER_PAGE,
                count: BrowseCfg.RESULTS_PER_PAGE,
                filters: null,
            },
        },
        skip: entityType === 'DATA_PRODUCT',
    });

    const onChangePage = (newPage: number) => {
        scrollToTop();
        history.push({
            pathname: rootPath,
            search: `&page=${newPage}`,
        });
    };

    if (page < 0 || page === undefined || Number.isNaN(page)) {
        return <Redirect to={`${PageRoutes.BROWSE}`} />;
    }

    return (
        <>
            <LegacyBrowsePath type={entityType} path={path} isBrowsable isLoading={loading} />
            {loading && <ComponentSpinner />}
            {error && <ErrorSection />}
            {entityType === 'DATA_PRODUCT' ? (
                <BrowseDataProduct />
            ) : (
                data?.browse &&
                !loading && (
                    <BrowseResults
                        type={entityType}
                        rootPath={rootPath}
                        page={page}
                        pageSize={BrowseCfg.RESULTS_PER_PAGE}
                        groups={data.browse.groups}
                        entities={data.browse.entities}
                        totalResults={data.browse.total}
                        onChangePage={onChangePage}
                    />
                )
            )}
        </>
    );
};
